export class BankDetailsModel {
  bankDetailsId?: number;
  bankName: string;
  bsb: string = '';
  accountNumber: string = '';
  accountName: string = '';
  reference: string = '';
}
